/* ==========================================================================
   text-reveal.js — RÉVÉLATION DU TEXTE MOT PAR MOT AU SCROLL (For.me)
   --------------------------------------------------------------------------
   À CHARGER dans theme.liquid, avec les autres scripts For.me :
     <script src="{{ 'text-reveal.js' | asset_url }}" defer></script>

   Les mots apparaissent au fur et à mesure que la section traverse l'écran.
   La progression est liée à la POSITION DE SCROLL, pas à une durée : si tu
   remontes, les mots s'effacent.

   v2 — ne dépend plus des événements 'scroll' (certains conteneurs ne les
   émettent pas sur window) : une boucle d'animation tourne uniquement quand
   le texte est à l'écran. Plus un filet de sécurité en bas de page.

   C'est un AJOUT, pas un override : aucune règle de Pitch n'est écrasée,
   rien ici ne porte de !important.
   ========================================================================== */
(function () {
  'use strict';

  /* ======================= RÉGLAGES (édite ici) =========================== */

  /* Quels textes animer. Une ligne par élément. Un sélecteur qui ne
     correspond à rien est ignoré : le texte reste normal, aucune erreur. */
  var CIBLES = [
    '#shopify-section-template--27113398600016__section_q8N4rn .text-block p',
  ];

  /* Fenêtre de scroll, en fraction de la hauteur d'écran.
     DEBUT = hauteur à laquelle le 1er mot commence à apparaître.
     FIN   = hauteur à laquelle le dernier mot est pleinement visible.
     Écarte les deux valeurs pour étaler l'effet sur plus de scroll. */
  var DEBUT = 0.85;
  var FIN = 0.45;

  /* Course minimale, en pixels de scroll.
     La course réelle vaut (DEBUT - FIN) × hauteur d'écran + hauteur du texte.
     Sur un petit écran ça peut devenir très court : ce plancher garantit que
     l'effet s'étale toujours sur au moins cette distance.
     Monte-le pour un effet plus lent, baisse-le pour un effet plus nerveux. */
  var COURSE_MIN_PX = 320;

  /* Nombre de mots en cours d'apparition EN MÊME TEMPS.
     C'est LA molette du fondu :
       1 = sec, les mots s'allument un par un
       3 = léger chevauchement (réglage actuel)
       6 = vague douce
      12 = très fondu, on ne distingue plus les mots */
  var FONDU = 1;

  /* Aspect d'un mot pas encore révélé. */
  var OPACITE_REPOS = 0.18; /* 0 = invisible, 1 = déjà lisible */
  var DECALAGE = 6; /* px de remontée pendant l'apparition, 0 = aucun mouvement */

  /* Passe à true, recharge la page, ouvre la console (F12) : le script
     affiche la progression en continu. 0 qui ne bouge pas = la fenêtre
     ci-dessus n'est jamais atteinte. Pas de log du tout = les CIBLES ne
     correspondent à rien. */
  var DEBUG = false;

  /* ======================= FIN DES RÉGLAGES =============================== */

  var CSS =
    '.fm-reveal__word{display:inline-block;will-change:opacity,transform}' +
    '@media (prefers-reduced-motion:reduce){.fm-reveal__word{opacity:1!important;transform:none!important}}';

  var items = [];
  var running = false;
  var visibleCount = 0;
  var reduced = false;
  var lastLog = 0;

  try {
    reduced =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  function injectCss() {
    if (document.getElementById('fm-reveal-css')) return;
    var s = document.createElement('style');
    s.id = 'fm-reveal-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  /* Découpe en mots SANS casser le HTML interne : on ne touche qu'aux noeuds
     de texte, donc un <strong>, un <em> ou un lien à l'intérieur survivent. */
  function wrapWords(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    var n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && n.nodeValue.trim()) nodes.push(n);
    }
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (!node.parentNode) continue;
      var parts = node.nodeValue.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        if (!p) continue;
        if (/^\s+$/.test(p)) {
          frag.appendChild(document.createTextNode(p));
        } else {
          var span = document.createElement('span');
          span.className = 'fm-reveal__word';
          span.textContent = p;
          frag.appendChild(span);
        }
      }
      node.parentNode.replaceChild(frag, node);
    }
  }

  var io = null;
  function observe(el) {
    if (!('IntersectionObserver' in window)) {
      visibleCount++; /* vieux navigateur : on anime en continu */
      return;
    }
    if (!io) {
      io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var was = entries[i].target._fmVisible === true;
            var now = entries[i].isIntersecting;
            if (was === now) continue;
            entries[i].target._fmVisible = now;
            visibleCount += now ? 1 : -1;
            if (visibleCount < 0) visibleCount = 0;
          }
          if (visibleCount > 0) start();
        },
        /* marge large : on commence à calculer avant que le texte entre */
        { rootMargin: '150% 0px 150% 0px', threshold: 0 }
      );
    }
    io.observe(el);
  }

  function collect() {
    items = [];
    var seen = [];
    for (var i = 0; i < CIBLES.length; i++) {
      var found;
      try {
        found = document.querySelectorAll(CIBLES[i]);
      } catch (e) {
        continue; /* sélecteur mal écrit : on ignore, on ne casse pas la page */
      }
      for (var j = 0; j < found.length; j++) {
        var el = found[j];
        if (seen.indexOf(el) !== -1) continue;
        seen.push(el);
        if (el.getAttribute('data-fm-reveal') !== 'done') {
          wrapWords(el);
          el.setAttribute('data-fm-reveal', 'done');
          el._fmVisible = false;
          observe(el);
        }
        var words = el.querySelectorAll('.fm-reveal__word');
        if (words.length) items.push({ el: el, words: words });
      }
    }
    if (DEBUG) {
      console.log(
        '[text-reveal] ' + items.length + ' texte(s) trouvé(s)',
        items.map(function (it) {
          return it.words.length + ' mots';
        })
      );
      if (!items.length) {
        console.warn('[text-reveal] aucune CIBLE ne correspond — vérifie le sélecteur');
      }
    }
  }

  /* Progression, mesurée UNIQUEMENT par la position du texte à l'écran.
     ------------------------------------------------------------------
     Aucune lecture de la position de scroll : selon le thème, la page peut
     défiler dans un conteneur interne plutôt que sur window, et dans ce cas
     window.pageYOffset reste bloqué à 0. getBoundingClientRect(), lui, est
     toujours juste — c'est la seule mesure fiable quel que soit le
     conteneur qui défile.

       p = 0  quand le haut du texte est à DEBUT (85 %) de la hauteur d'écran
       p = 1  après avoir parcouru COURSE pixels vers le haut

     La course inclut la hauteur du texte : un paragraphe haut met donc
     naturellement plus de scroll à se révéler qu'une seule ligne. */
  function progress(el, rect, vh) {
    var ligneDebut = vh * DEBUT;
    var course = vh * (DEBUT - FIN) + rect.height;
    if (course < COURSE_MIN_PX) course = COURSE_MIN_PX;

    var p = (ligneDebut - rect.top) / course;

    el._fmDebug = {
      p: p,
      top: rect.top,
      ligneDebut: ligneDebut,
      course: course,
      hauteur: rect.height,
      vh: vh,
    };
    return p < 0 ? 0 : p > 1 ? 1 : p;
  }

  function frame() {
    if (!items.length || visibleCount <= 0) {
      running = false;
      return;
    }
    var vh = window.innerHeight || document.documentElement.clientHeight;

    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.el.isConnected) continue;
      var p = progress(it.el, it.el.getBoundingClientRect(), vh);

      if (DEBUG && Date.now() - lastLog > 250) {
        lastLog = Date.now();
        var d = it.el._fmDebug || {};
        console.log(
          '[text-reveal] p=' + p.toFixed(3) +
            ' | top=' + Math.round(d.top) +
            ' ligneDébut=' + Math.round(d.ligneDebut) +
            ' course=' + Math.round(d.course) +
            ' hauteurTexte=' + Math.round(d.hauteur) +
            ' vh=' + Math.round(d.vh)
        );
      }

      var n = it.words.length;
      var total = n + FONDU;
      for (var j = 0; j < n; j++) {
        var k = (p * total - j) / FONDU;
        if (k < 0) k = 0;
        else if (k > 1) k = 1;

        var w = it.words[j];
        if (w._fmK === k) continue; /* rien n'a bougé pour ce mot */
        w._fmK = k;
        w.style.opacity = (OPACITE_REPOS + (1 - OPACITE_REPOS) * k).toFixed(3);
        w.style.transform = DECALAGE
          ? 'translateY(' + ((1 - k) * DECALAGE).toFixed(2) + 'px)'
          : '';
      }
    }
    window.requestAnimationFrame(frame);
  }

  function start() {
    if (running) return;
    running = true;
    window.requestAnimationFrame(frame);
  }

  function init() {
    collect();
    if (!items.length) return;
    injectCss();
    if (reduced) return; /* accessibilité : tout reste lisible, aucun effet */
    /* premier rendu immédiat, puis la boucle prend le relais dès que le
       texte approche de l'écran */
    visibleCount = visibleCount || 1;
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* L'éditeur de thème redessine une section à chaque modification. */
  document.addEventListener('shopify:section:load', function () {
    init();
    start();
  });
})();